import React from "react";
import "./Button.css";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

export default function Button({ btnLink, btnText }) {
  return (
    <div className="btn">
      <Link to={`${btnLink}`}>
        {btnText}
        <FiArrowRight />
      </Link>
    </div>
  );
}
